module.exports = __webpack_public_path__ + "img/Control-Public-Information.f0ef65f6.png";